import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs/Observable";
import { AuthService } from "../auth/auth.service";

@Injectable()
export class LoggedInGuardService implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(["/projects"]);
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/logged-in-guard/logged-in-guard.service.ts